import { View } from 'react-native'
import styled from 'styled-components/native'
import { ResponsiveView } from 'APP/Converse/Layout'
import Button from 'APP/Converse/Button'

export const StyledContainerView = styled(View)`
  display: flex;
  flex: 1;
  background-color: ${({ theme }) => theme.colors.videoBg};
  align-items: center;
  justify-content: center;
`

export const StyledResponsiveView = styled(ResponsiveView)`
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  padding-bottom: 150px;
`

export const StyledButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.buttonLinen};
`
